import styled from "styled-components";
const NotFoundPageDisplay = styled.div`
	// my css here
`;	export default NotFoundPageDisplay;
